const FORM_COL_SIZING = {
  mobile: 16,
  tablet: 8,
  computer: 8,
  largeScreen: 5,
  widescreen: 5,
}

const FORM_COL_FULL_SIZING = {
  mobile: 16,
  tablet: 16,
  computer: 16,
  largeScreen: 16,
  widescreen: 16,
}

const FORM_TWO_COLS_SIZING = {
  mobile: 16,
  tablet: 16,
  computer: 8,
  largeScreen: 8,
  widescreen: 8,
}

const FORM_TWO_COLS_NARROW_SIZING = {
  mobile: 16,
  tablet: 16,
  computer: 5,
  largeScreen: 4,
  widescreen: 3,
}

const FORM_TWO_COLS_WIDE_SIZING = {
  mobile: 16,
  tablet: 16,
  computer: 11,
  largeScreen: 12,
  widescreen: 13,
}

export default {
  FORM_COL_SIZING,
  FORM_COL_FULL_SIZING,
  FORM_TWO_COLS_SIZING,
  FORM_TWO_COLS_NARROW_SIZING,
  FORM_TWO_COLS_WIDE_SIZING,
}
